import { useRef, useState, useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Typography } from 'antd'
import _ from 'lodash'
import cx from 'classnames'
import { ProposalSection, Toast, FormLoader, Tip, Button } from '@vzmi/shp_shared_compo'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { httpHandler } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import styles from '../index.css'
import batchStyles from './index.css'
import {
  checkResultWithDiscountCount,
  mergeAbandonedDataIntoListings,
  orderByIds
} from './helper'
import CommonPage from '../../../containers/Proposal/Common/CommonPage'
import ProposalCompletion from '../../Proposal/Common/ProposalCompletion/ProposalCompletion'
import { IconPopoverLabel } from '../../Proposal/Common/ProposalForm/FormLabelTooltip/FormLabelTooltip'
import Feature from '../Feature'
import {
  HyperLink, FormRow,
  RadioGroupInputField,
  InputField,
  TextareaCountField,
  RFSelectInputField,
  InputCountField
} from '../../Common/Form'
import { Field, formDecorator } from '../../Common/forms'
import { ConnectedListingLink } from '../../Common/ListingLink/ListingLink'
import { getFormValues } from '../../Proposal/Common/ProposalForm/Shared/util'
import { dollarFormat, scrollTo } from '../../../../lib/renderUtil'
import { removeNotNumberAndComma } from '../../../lib/parser'
import { idsValidation, getIdsCountFromValue } from '../../Proposal/ProductListingBaseForm/ListingModel/ExtraModelTable/helper'
import { EMPTY_VALUE, API_ERROR_MAPPING } from '../../../constants/globalTypes'
import batchProposals from '../request/batchProposals'
import { atLeast, filterHtmlTagAndSpace } from '../../Proposal/Common/ProposalForm/Shared/normalizers'
import {
  COUPON_FIELD as IMPORT_COUPON_FIELD,
  RADIO_DISCOUNT_RULE_TYPES,
  RADIO_IS_ALLOWED_ACTIVITY_TYPES,
  DURATION_DEFAULT_VALUES,
  onChangeDiscountRadioField,
  onChangeDiscountInputField,
  formatedEffectiveTime,
  MODAL_DEFAULT_VALUES,
  SearchText
} from '../../Dashboard/OperatingDashboard/CustomerInterest/ECouponModal/ECouponModal'
import {
  getListingsData,
  getListingCostData
} from '../../Dashboard/OperatingDashboard/CustomerInterest/CustomerInterest'
import {
  getProductBundlesData,
  getConvertedCreatedPayload
} from '../../Dashboard/OperatingDashboard/CustomerInterest/withSharedModalsActions'
import {
  validateCouponDiscountCount,
  validateCouponTitle,
  validateCouponMinQtyDiscountAmount,
  validateCouponMinTotalDiscountAmount,
  validateCouponDuration
} from '../../Proposal/Common/ProposalForm/Shared/validation/fieldLevelValidator'
import { getListingImage, getCouponImage } from '../../Dashboard/OperatingDashboard/Shared'
import { TARGET_AUDIENCE } from '../../Dashboard/OperatingDashboard/CustomerInterest/RankingTable/RankingTable'
import { showOnlyNumber, showNoEmoji } from '../../../lib/formatter'
import { withI13nWrapper } from '../../Common/I13nWrapper'
import useI13N from '../hook/useI13N'

const COUPON_FIELD = {
  ...IMPORT_COUPON_FIELD,
  TARGET_AUDIENCE: 'targetAudience'
}

const TARGET_OPTIONS = [
  { label: '截至昨日購物未結帳之買家', value: TARGET_AUDIENCE.ABANDONED_CART },
  { label: '昨日加入購物車之買家', value: TARGET_AUDIENCE.YESTERDAY_ABANDONED_CART }
]

const LISTING_IDS_LIMIT = 50

const FORM_CONFIG = {
  form: 'BATCH_COUPON_FORM',
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true // unregister fields on unmount
}

const getIsAbandonedCart = (targetAudience) =>
  targetAudience === TARGET_AUDIENCE.ABANDONED_CART

const CouponForm = ({
  listingsInfoData: { listing = {}, promotion = {} } = {},
  onNumTotalChange,
  triggerFieldChange,
  reduxFormState,
  formVisible,
  initialize
}) => {
  const formValues = getFormValues(reduxFormState) || {}
  const {
    title, promotionEndTs
  } = promotion
  const {
    id: listingId,
    name: listingName,
    yesterdayQuantity, quantity, // from stats api
    price: couponPrice,
    endTs: listingEndTs
  } = listing
  const imageUrl = getListingImage(listing)
  const cost = getListingCostData(listing)
  const targetAudience = formValues[COUPON_FIELD.TARGET_AUDIENCE]
  const isAbandonedCart = getIsAbandonedCart(targetAudience)
  // 如果有 listingId 則為批次各賣場的 form
  const batchSerial = listingId ? `batch_${listingId}_` : ''

  const {
    [`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT}`]: minQtyDiscountAmount = listingId ? formValues[COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT] : 0,
    [`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT}`]: minTotalDiscountAmount = listingId ? formValues[COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT] : 0,
    [`${batchSerial}${COUPON_FIELD.IS_ALLOWED_ACTIVITY}`]: isAllowedActivityStatus = listingId ? formValues[COUPON_FIELD.IS_ALLOWED_ACTIVITY] : true,
    [`${batchSerial}${COUPON_FIELD.DISCOUNT_COUNT}`]: discountCount = listingId ? formValues[COUPON_FIELD.DISCOUNT_COUNT] : 1
  } = formValues

  const numTotal = discountCount * (minQtyDiscountAmount || minTotalDiscountAmount || 0)
  useEffect(() => {
    if (listingId) {
      onNumTotalChange(listingId, numTotal)
    }
  }, [listingId, numTotal, onNumTotalChange])

  return (
    <>
      {batchSerial && (
        <>
          <FormRow
            className={batchStyles.listingInfo}
            label={(
              <img
                className={batchStyles.img}
                src={imageUrl}
              />
            )}
            data-role='listingInfo'
          >
            <div className={batchStyles.name}>
              <ConnectedListingLink targetListingId={listingId}>
                {listingId}
              </ConnectedListingLink>
              <Typography.Paragraph
                className={batchStyles.paragraph}
                strong
                ellipsis={{ rows: 1 }}
              >
                {listingName}
              </Typography.Paragraph>
            </div>
            <p
              className={batchStyles.halfWidth}
              data-role='price'
            >
              {`目前售價：${dollarFormat(+couponPrice)}`}
            </p>
            <p className={batchStyles.halfWidth}>
              成本：
              <span
                className={batchStyles.cost}
                data-role='cost'
              >
                {dollarFormat(showOnlyNumber(cost)) || EMPTY_VALUE}
              </span>
            </p>
            {
              (title && promotionEndTs) && (
                <>
                  <div className={batchStyles.flag}>活動</div>
                  <div className={batchStyles.promotions}>
                    <p className={batchStyles.title}>{title}</p>
                    <p className={batchStyles.promotionEndTs}>{`有效至${formatedEffectiveTime(promotionEndTs)}`}</p>
                  </div>
                </>
              )
            }
          </FormRow>
          <FormRow
            label='折價券名稱'
            labelAlign='top'
            className={batchStyles.resetFormMargin}
          >
            <Row align='middle'>
              <Col>
                <p>購物車專屬折價券-</p>
              </Col>
              <Col data-role='titleBlock'>
                <Field
                  name={`${batchSerial}${COUPON_FIELD.TITLE}`}
                  defaultValue={listingName}
                  type='text'
                  className={batchStyles.titleField}
                  component={InputCountField}
                  countLimit={41}
                  validate={validateCouponTitle}
                  normalizeOnBlur={filterHtmlTagAndSpace}
                  format={showNoEmoji}
                  showErrorOnActive
                  mustShowFormError
                />
              </Col>
            </Row>
          </FormRow>
          <FormRow
            label={(
              <IconPopoverLabel
                popoverContent='送出折價券後，系統會自動剔除已經完成結帳之買家。'
              >
                發送對象
              </IconPopoverLabel>
            )}
            labelAlign='top'
            className={batchStyles.resetFormMargin}
          >
            <Row>
              <Col span={24}>
                <Tip type='info'>
                  折價券發送順序以加入時間近者優先。
                </Tip>
              </Col>
              <Row align='middle'>
                <Col data-role='discountCountBlock'>
                  <Field
                    key={targetAudience}
                    name={`${batchSerial}${COUPON_FIELD.DISCOUNT_COUNT}`}
                    type='text'
                    className={batchStyles.discountCountField}
                    component={InputField}
                    validate={validateCouponDiscountCount(isAbandonedCart ? quantity : yesterdayQuantity)}
                    parse={showOnlyNumber}
                    normalizeOnBlur={atLeast(1)}
                    showErrorOnActive
                    mustShowFormError
                  />
                </Col>
                <Col>
                  {
                    isAbandonedCart
                      ? (<p className={batchStyles.defaultSpacing}>位截至昨日購物未結帳之買家</p>)
                      : (<p className={batchStyles.defaultSpacing}>位昨日加入購物車之買家</p>)
                  }
                </Col>
              </Row>
            </Row>
          </FormRow>
        </>
      )}
      <FormRow
        label='折抵方式'
        labelAlign='top'
        className={batchStyles.resetFormMargin}
      >
        <Row>
          <Col span={2}>
            <Field
              name={`${batchSerial}${COUPON_FIELD.DISCOUNT_RULE}`}
              component={RadioGroupInputField}
              buttonStyle='outline'
              options={RADIO_DISCOUNT_RULE_TYPES}
              className={batchStyles.discountRuleField}
              onChange={onChangeDiscountRadioField(triggerFieldChange)}
              showErrorOnActive
              mustShowFormError
            />
          </Col>
          <Col span={22}>
            <Row
              align='middle'
              className={batchStyles.discountBlock}
            >
              <Col>
                <p className={batchStyles.defaultSpacing}>滿</p>
              </Col>
              <Col>
                <Field
                  name={`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_THRESHOLD}`}
                  type='text'
                  component={InputField}
                  className={batchStyles.discountThresholdField}
                  onChange={onChangeDiscountInputField(triggerFieldChange)}
                  parse={showOnlyNumber}
                  showErrorOnActive
                  mustShowFormError
                />
              </Col>
              <Col>
                <p className={batchStyles.defaultSpacing}>件，折</p>
              </Col>
              <Col data-role='minQtyDiscountAmountBlock'>
                <Field
                  name={`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT}`}
                  type='text'
                  component={InputField}
                  className={batchStyles.discountAmountField}
                  onChange={onChangeDiscountInputField(triggerFieldChange)}
                  { ...batchSerial
                    ? { validate: validateCouponMinQtyDiscountAmount(cost, batchSerial) }
                    : {}
                  }
                  parse={showOnlyNumber}
                  showErrorOnActive
                  mustShowFormError
                />
              </Col>
              <Col>
                <p className={batchStyles.defaultSpacing}>元。</p>
              </Col>
            </Row>
            <Row align='middle'>
              <Col>
                <p className={batchStyles.defaultSpacing}>滿</p>
              </Col>
              <Col>
                <Field
                  name={`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_THRESHOLD}`}
                  type='text'
                  component={InputField}
                  className={batchStyles.discountThresholdField}
                  onChange={onChangeDiscountInputField(triggerFieldChange)}
                  parse={showOnlyNumber}
                  showErrorOnActive
                  mustShowFormError
                />
              </Col>
              <Col>
                <p className={batchStyles.defaultSpacing}>元，折</p>
              </Col>
              <Col data-role='minTotalDiscountAmountBlock'>
                <Field
                  name={`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT}`}
                  type='text'
                  component={InputField}
                  className={batchStyles.discountAmountField}
                  onChange={onChangeDiscountInputField(triggerFieldChange)}
                  validate={validateCouponMinTotalDiscountAmount(cost, +couponPrice, batchSerial)}
                  parse={showOnlyNumber}
                  showErrorOnActive
                  mustShowFormError
                />
              </Col>
              <Col>
                <p className={batchStyles.defaultSpacing}>元。</p>
              </Col>
            </Row>
          </Col>
        </Row>
        {listingId && (
          <Row>
            <Col>
              <p
                className={batchStyles.dollarTotal}
                data-role='numTotalBlock'
              >
                {`預計最高將收取費用 ${dollarFormat(numTotal)} 元。`}
              </p>
            </Col>
          </Row>
        )}
      </FormRow>
      <FormRow
        label={(
          <IconPopoverLabel
            popoverContent={(
              <>
                • 發送後即刻生效，結束時間為您設定的期限
                <br />
                • 舉例：當下是 9/1 10:00, 您設定2日，則折價券有效期間為 9/1 10:00 ~ 9/3: 9:59
                <br />
                • 送出至發送可能會有5分鐘時間差
              </>
            )}
          >
            有效天數
          </IconPopoverLabel>
        )}
        labelAlign='top'
        className={batchStyles.resetFormMargin}
      >
        <Row>
          <Col span={24}>
            <Tip type='info'>
              發送後即刻生效，結束時間為您設定的期限。
            </Tip>
          </Col>
          <Row align='middle'>
            <Col
              className={batchStyles.durationBlock}
              data-role='durationBlock'
            >
              <Field
                name={`${batchSerial}${COUPON_FIELD.DURATION}`}
                type='text'
                component={InputField}
                className={batchStyles.durationField}
                parse={showOnlyNumber}
                validate={validateCouponDuration(listingEndTs)}
                normalizeOnBlur={atLeast(DURATION_DEFAULT_VALUES)}
                showErrorOnActive
                mustShowFormError
              />
            </Col>
            <Col>
              <p className={batchStyles.defaultSpacing}>日</p>
            </Col>
          </Row>
        </Row>
      </FormRow>
      <FormRow
        label='與活動同步折抵'
        labelAlign='top'
        className={batchStyles.resetFormMargin}
      >
        <Row>
          <Col span={24}>
            <Field
              name={`${batchSerial}${COUPON_FIELD.IS_ALLOWED_ACTIVITY}`}
              data-role='isAllowedActivity'
              component={RadioGroupInputField}
              buttonStyle='outline'
              options={RADIO_IS_ALLOWED_ACTIVITY_TYPES}
              className={batchStyles.isAllowedActivity}
              showErrorOnActive
              mustShowFormError
            />
            <div
              className={batchStyles.isAllowedActivityText}
              data-role='isAllowedActivityBlock'
            >
              {isAllowedActivityStatus
                ? '即雙享券，折價券可以與活動疊加折抵訂單金額。'
                : '若賣場有活動，則活動與折價券無法同時折抵。'
              }
            </div>
          </Col>
        </Row>
      </FormRow>
    </>
  )
}

// 由 listingIds 查詢賣場(用getListingsData)，並回傳結果為 listingsData
const importListings = async ({
  fetchAbandonedCarts, fetchListings, setListings, setIsLoading, setImportError,
  reduxFormState, initialize
}) => {
  const formValues = getFormValues(reduxFormState) || {}
  const listingIds = formValues && formValues[COUPON_FIELD.LISTING_ID]
  if (_.isEmpty(listingIds)) {
    setImportError('請至少選擇一個賣場')
    return
  }
  if (listingIds.split(COMMA).length > LISTING_IDS_LIMIT) {
    setImportError(`最多輸入 ${LISTING_IDS_LIMIT} 筆`)
    return
  }
  setIsLoading(true)

  // getting stats/abandonedCarts data for quantity, yesterdayQuantity
  const [abandonedCartsError, abandonedCartsData = []] =
    await getListingsData(
      null,
      (params) => fetchAbandonedCarts(params).then(httpHandler),
      { listingIds, limit: 50 },
      'abandonedCarts'
    )

  if (abandonedCartsError) {
    Toast.error(`取得未結帳資料失敗：${abandonedCartsError.message}`)
    setIsLoading(false)
    return
  }

  // getting listing data
  const [listingsError, listingsData = []] = await getListingsData(listingIds, (params) => fetchListings(params).then(httpHandler))
  setIsLoading(false)

  if (listingsError) {
    Toast.error(`取得賣場資料失敗：${listingsError.message}`)
    return
  }

  // 將賣場資訊及未結帳資訊資料合併，並依照step1選擇的折價券發送對象作剔除邏輯
  const targetAudience = formValues[COUPON_FIELD.TARGET_AUDIENCE]
  const isAbandonedCart = getIsAbandonedCart(targetAudience)
  const mergedListingsData = mergeAbandonedDataIntoListings(abandonedCartsData, listingsData, isAbandonedCart)

  // 若和原本的 listingIds 不同，則顯示錯誤訊息
  const listingIdsArray = listingIds.split(COMMA)
  const ignoredIdsArray = _.difference(listingIdsArray, mergedListingsData.map(listing => listing.id.toString()))
  if (!_.isEmpty(ignoredIdsArray)) {
    setImportError(`已自動略過賣場 ${ignoredIdsArray.join(COMMA)}`)
  } else {
    setImportError('')
  }
  const sortedListingsData = orderByIds(mergedListingsData, listingIdsArray)
  setListings(sortedListingsData)

  const getValueFromStep2 = field => formValues[field]

  let defaultValues = {
    ...formValues,
    // 更新填入的賣場ID 略過ignoredIds
    [COUPON_FIELD.LISTING_ID]: listingIdsArray.filter(id => !ignoredIdsArray.includes(id)).join(COMMA)
  }
  mergedListingsData.forEach(listing => {
    const { id, name, quantity, yesterdayQuantity } = listing
    const batchSerial = `batch_${id}_`

    defaultValues = {
      ...defaultValues,
      [`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_THRESHOLD}`]: getValueFromStep2(COUPON_FIELD.MIN_QTY_DISCOUNT_THRESHOLD),
      [`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT}`]: getValueFromStep2(COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT),
      [`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_THRESHOLD}`]: getValueFromStep2(COUPON_FIELD.MIN_TOTAL_DISCOUNT_THRESHOLD),
      [`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT}`]: getValueFromStep2(COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT),
      [`${batchSerial}${COUPON_FIELD.DISCOUNT_RULE}`]: getValueFromStep2(COUPON_FIELD.DISCOUNT_RULE),
      [`${batchSerial}${COUPON_FIELD.DURATION}`]: getValueFromStep2(COUPON_FIELD.DURATION),
      [`${batchSerial}${COUPON_FIELD.IS_ALLOWED_ACTIVITY}`]: getValueFromStep2(COUPON_FIELD.IS_ALLOWED_ACTIVITY),
      [`${batchSerial}${COUPON_FIELD.TITLE}`]: name,
      [`${batchSerial}${COUPON_FIELD.DISCOUNT_COUNT}`]: isAbandonedCart ? quantity : yesterdayQuantity
    }
  })

  initialize(defaultValues)
}

const submitCoupons = async ({
  formValues, listings,
  setResults, setIsLoading,
  createSupplierCoupons
}) => {
  // POST /product/v1/supplierCoupons
  setIsLoading(true)
  const listingIds = formValues[COUPON_FIELD.LISTING_ID].split(COMMA) || []
  const paramsList = listingIds.map(id => {
    const listingId = Number(id)
    const batchSerial = `batch_${listingId}_`
    const imageUrl = getCouponImage(listings.find(item => item.id === listingId)) || null
    const pickedFormValues = {
      [COUPON_FIELD.MIN_QTY_DISCOUNT_THRESHOLD]: formValues[`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_THRESHOLD}`],
      [COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT]: formValues[`${batchSerial}${COUPON_FIELD.MIN_QTY_DISCOUNT_AMOUNT}`],
      [COUPON_FIELD.MIN_TOTAL_DISCOUNT_THRESHOLD]: formValues[`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_THRESHOLD}`],
      [COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT]: formValues[`${batchSerial}${COUPON_FIELD.MIN_TOTAL_DISCOUNT_AMOUNT}`],
      [COUPON_FIELD.DISCOUNT_RULE]: formValues[`${batchSerial}${COUPON_FIELD.DISCOUNT_RULE}`],
      [COUPON_FIELD.DURATION]: formValues[`${batchSerial}${COUPON_FIELD.DURATION}`],
      [COUPON_FIELD.IS_ALLOWED_ACTIVITY]: formValues[`${batchSerial}${COUPON_FIELD.IS_ALLOWED_ACTIVITY}`],
      [COUPON_FIELD.TITLE]: formValues[`${batchSerial}${COUPON_FIELD.TITLE}`],
      [COUPON_FIELD.DISCOUNT_COUNT]: formValues[`${batchSerial}${COUPON_FIELD.DISCOUNT_COUNT}`],
      [COUPON_FIELD.TARGET_AUDIENCE]: formValues[COUPON_FIELD.TARGET_AUDIENCE],
      listingId,
      ...imageUrl && { imageUrl }
    }
    return getConvertedCreatedPayload(pickedFormValues)
  })
  const actions = { createProposals: createSupplierCoupons }

  const batchResult = await batchProposals(
    actions,
    paramsList
  )
  setResults(checkResultWithDiscountCount(batchResult))
  setIsLoading(false)
  scrollTo(0)
}

const BatchMain = (props) => {
  const {
    actions: {
      fetchProductBundles,
      fetchListings,
      fetchAbandonedCarts,
      createSupplierCoupons
    },
    setResults,
    listings, setListings, promotions, setPromotions,
    reduxFormState,
    reduxFormState: {
      values: formValues,
      syncErrors
    },
    initialize,
    triggerFieldChange
  } = props
  const [isLoading, setIsLoading] = useState(false)
  const [importError, setImportError] = useState('')
  const [couponCostMap, setCouponCostMap] = useState({})
  const onNumTotalChange = useCallback((listingId, numTotal) => {
    setCouponCostMap(prev => ({ ...prev, [listingId]: numTotal }))
  }, [])
  const totalCouponCost = listings.reduce((sum, listing) => {
    const couponCost = couponCostMap[listing.id] || 0
    return sum + couponCost
  }, 0)

  // initialValues for step2 forms process once when mounts
  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      initialize({
        ...MODAL_DEFAULT_VALUES,
        [COUPON_FIELD.TARGET_AUDIENCE]: TARGET_AUDIENCE.ABANDONED_CART
      })
    }
  }, [initialize, formValues])

  const reset = (e, isResetStep2) => {
    setListings([])
    setPromotions([])
    setImportError('')
    triggerFieldChange(e)
    if (isResetStep2) {
      initialize({
        ...formValues,
        [COUPON_FIELD.LISTING_ID]: ''
      })
    }
  }

  const getIdsCount = (isInputProps = true) => target => getIdsCountFromValue(target, isInputProps)

  return (
    <FormLoader
      isLoading={isLoading}
      fixed
    >
      <ProposalSection
        className={styles.proposalSection}
      >
        <Feature
          content={[
            (
              <>
                折價券發送對象與賣場來源：
                <HyperLink
                  href='/item/customerInterestAbandonedCart'
                  target='_blank'
                >
                  購物未結帳
                </HyperLink>
              </>),
            '折價券發送產生之折價券費用將由貴公司100%負擔，雅虎將自動產生費用並於貨款中扣除。'
          ]}
        />
      </ProposalSection>
      <ProposalSection
        title='Step1. 選擇折價券發送對象'
        className={styles.proposalSection}
      >
        <Field
          name={COUPON_FIELD.TARGET_AUDIENCE}
          component={RFSelectInputField}
          className={batchStyles.targetAudience}
          options={TARGET_OPTIONS}
          onChange={e => reset(e)}
        />

      </ProposalSection>
      <ProposalSection
        title='Step2. 套用折價券內容'
        className={cx(styles.proposalSection, batchStyles.batchUpload)}
      >
        <div className={cx(styles.container, batchStyles.container)}>
          <CouponForm {...props} />
        </div>
      </ProposalSection>
      <ProposalSection
        title='Step3. 匯入折價券發送賣場'
        className={cx(styles.proposalSection, batchStyles.batchUpload)}
      >
        <div className={cx(styles.container, batchStyles.container)}>
          匯入的賣場若無發送對象或不符合折價券發送規定，將自動略過。
          <Field
            name={COUPON_FIELD.LISTING_ID}
            component={TextareaCountField}
            className={batchStyles.listingIds}
            placeholder={`請輸入賣場編號，並以逗號或 enter 分隔，最多輸入 ${LISTING_IDS_LIMIT} 筆`}
            parse={removeNotNumberAndComma}
            validate={idsValidation(LISTING_IDS_LIMIT, getIdsCount(false))}
            countLimit={LISTING_IDS_LIMIT}
            customizeGetCount={getIdsCount(true)}
          />
          <div className={batchStyles.importDescription}>
            {importError}
          </div>
          <Button
            type='primary'
            size='large'
            onClick={() => importListings({
              fetchAbandonedCarts,
              fetchListings,
              listings,
              setListings,
              promotions,
              setPromotions,
              setIsLoading,
              setImportError,
              reduxFormState,
              initialize
            })}
          >
            匯入並產生折價券內容
          </Button>
        </div>
      </ProposalSection>
      {!_.isEmpty(listings) && (
        <ProposalSection
          title='Step4. 設定折價券內容'
          className={cx(styles.proposalSection, batchStyles.batchUpload)}
        >
          <ListingGridCard
            listings={listings}
            promotions={promotions}
            fetchProductBundles={fetchProductBundles}
            onNumTotalChange={onNumTotalChange}
            {...props}
          />
          <div className={batchStyles.footerTextBlock}>
            <Button
              disabled={isLoading || !_.isEmpty(syncErrors)}
              className={batchStyles.submitBtn}
              onClick={() => submitCoupons({
                formValues,
                listings,
                setResults,
                setIsLoading,
                createSupplierCoupons
              })}
              size='large'
              data-role='submitCoupon'
            >
              送出折價券
            </Button>
            <Button
              onClick={(e) => { reset(e, true) }}
              size='large'
              color='gray'
              data-role='cancelCoupon'
            >
              取消
            </Button>
            <div className={batchStyles.footerTextBlock}>
              「送出折價券」表示貴公司同意產生之折價券費用將由貴公司 100% 負擔，
              <br />
              預計最高將收取費用&nbsp;
              {dollarFormat(totalCouponCost)}
              &nbsp;元，雅虎將自動產生費用並於貨款中扣除。
            </div>
          </div>
        </ProposalSection>
      )}
    </FormLoader>
  )
}

// map 使用 ListingCard 列出所有查詢結果的賣場
const ListingGridCard = ({ listings, ...props }) => (
  <div className={batchStyles.gridContainer}>
    {listings.map((listing, index) => (
      <div
        className={batchStyles.gridItem}
        key={index}
      >
        <ListingCard
          listing={listing}
          {...props}
        />
      </div>
    ))}
  </div>
)

// 使用 CouponForm 並加入賣場資訊的單一折價券表單
const ListingCard = ({ listing, fetchProductBundles, ...props }) => {
  // getting one productBundles data for promotion
  const [promotionData, setPromotionData] = useState({})

  const isFirstRender = useRef(true)
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false
      const fetchPromotions = async () => {
        const [error, data = {}] = await getProductBundlesData(
          listing.id,
          (params) => fetchProductBundles(params).then(httpHandler)
        )

        if (error) {
          Toast.error(`取得活動資料失敗：${error.message}`)
          console.error(error)
        } else {
          setPromotionData(data)
        }
      }
      fetchPromotions()
    }
  }, [listing.id, fetchProductBundles])

  return (
    <CouponForm
      listingsInfoData={{
        listing,
        promotion: promotionData
      }}
      {...props}
    />
  )
}

const ResultListing = ({ className, results, listings }) => (
  <div className={className}>
    {results.map((
      [
        { message: errorMessage = '', params = {}, error = { code: 0, detail: [] } } = {},
        { discountId, discountCount, title } = {}
      ],
      index
    ) => {
      if (discountId) {
        return (
          <div key={index}>
            <h4>
              折價券編號：
              <LinkContainer
                successData={{ discountId }}
                hasIdStatus
              />
            </h4>
            <p>
              折價券（
              {title}
              ）已發送給
              <b>
                {discountCount}
              </b>
              位買家
            </p>
          </div>
        )
      }
      // 當折價券發送中，API會回應錯誤，但應顯示為
      const listingId = _.get(params, 'listingIds.0', '')
      const listingName = _.get(listings.find(item => item.id === listingId), 'name') || ''
      const errorCode = error.code
      const previousCouponDeadline = errorCode === 42900003
        ? _.flow(
          () => _.get(error, 'detail[0].invalidValue', ''),
          // ex: ': 2023/11/17 09:46' -> '11/17 09:46'
          invalidValue => _.replace(invalidValue, /:\s\d{4}\//, '')
        )()
        : ''
      if (errorCode === 40900002) {
        return (
          <div key={index}>
            <h4>折價券發送中</h4>
            <p>
              賣場
              <b>
                <ConnectedListingLink targetListingId={listingId}>
                  {listingId}
                </ConnectedListingLink>
              </b>
              { listingName }
              {API_ERROR_MAPPING[errorCode]}
              ，請等待幾分鐘後，至
              <LinkToCouponSystem />
              查看折價券發放與使用狀況
            </p>
          </div>
        )
      }
      return (
        <div
          key={index}
          className={batchStyles.badResult}
        >
          <h4>折價券未成功發送</h4>
          <p>
            賣場
            <b>
              <ConnectedListingLink targetListingId={listingId}>
                {listingId}
              </ConnectedListingLink>
            </b>
            { listingName }
            折價券未成功發送：
            <span>
              {errorMessage}
              {previousCouponDeadline}
            </span>
          </p>
        </div>
      )
    })}
  </div>
)

const CouponDispatch = ({
  reduxFormState,
  initialize,
  i13nMethods,
  ...props
}) => {
  const [listings, setListings] = useState([])
  const [promotions, setPromotions] = useState([])
  const [results, setResults] = useState([])

  const i13nData = {
    proposalType: 'coupon',
    queryStringListingIds: listings.map(listing => listing.id).join(COMMA)
  }
  const pageFlow = {
    isEditPage: results.length === 0,
    isSuccessPage: results.length > 0
  }
  useI13N(i13nMethods, i13nData, pageFlow, 'batch')

  return (
    <CommonPage>
      { (results.length > 0 && (
        <ProposalCompletion
          title='折價券已發送'
          withHint={false}
        >
          <p className={batchStyles.completeHint}>
            <LinkContainer />
          </p>
          <ResultListing
            className={batchStyles.results}
            results={results}
            listings={listings}
          />
          <div className={batchStyles.finalActions}>
            <HyperLink
              target='_blank'
              href={window.location.href}
              className={batchStyles.newPageBtn}
            >
              繼續發送折價券
            </HyperLink>
          </div>
        </ProposalCompletion>
      )) || (
        <BatchMain
          { ...({
            setResults,
            listings,
            setListings,
            promotions,
            setPromotions,
            reduxFormState,
            initialize,
            ...props
          })}
        />
      )}
    </CommonPage>
  )
}

const mapStateToProps = state => ({
  supplier: state.supplier
})

const LinkContainer = connect(
  mapStateToProps
)(SearchText)

const LinkToCouponSystem = connect(
  mapStateToProps
)(props => (
  <HyperLink
    href={_.get(props, 'supplier.sharedLink.scmQueryCampaign')}
    target='_blank'
  >
    我的折價券
  </HyperLink>
))

const hoc = component => withI13nWrapper(formDecorator(FORM_CONFIG)(component))

export default hoc(CouponDispatch)
